<template>
  <div v-loading="loading" class="detail-box">
    <template v-if="detail">
      <el-card class="card">
        <p class="sub-title">基础信息</p>

        <div class="base-info">
          <div>
            <span>流水ID</span>
            <span>{{ detail.id }}</span>
          </div>
          <div>
            <span>提交用户</span>
            <span>{{ detail.companyName }}</span>
          </div>

          <div>
            <span>来源</span>
            <span>{{ fromMap[detail.fFrom] }}</span>
          </div>

          <div>
            <span>用户类型</span>
            <span>{{ userMap[detail.companyType] }}</span>
          </div>

          <div>
            <span>申诉类型</span>
            <span>{{ auditMap[detail.appealType] }}</span>
          </div>

          <div>
            <span>申诉原因</span>
            <span>{{ detail.rejectReason }}</span>
          </div>

          <div>
            <span>提交时间</span>
            <span>{{ detail.insertTime }}</span>
          </div>

          <div>
            <span>审核状态</span>
            <span>{{ reviewStatusMap[detail.reviewStatus] }}</span>
          </div>
        </div>
      </el-card>

      <el-card class="card">
        <p class="sub-title">申诉材料</p>

        <div class="info">
          <div class="license-file">
            <span>授权文件</span>
            <span>
              <el-button
                v-for="file in detail.reviewTrackLicenseList"
                type="text"
                :key="file.id"
                @click="handleClickOpen(file.url)"
              >
                {{ file.fileName }}
              </el-button>
            </span>
          </div>
          <br>

          <div>
            <span>侵权投诉通知书</span>
            <span>-</span>
          </div>

          <div>
            <span>权利人权属证明</span>
            <span>-</span>
          </div>

          <div>
            <span>营业执照副本</span>
            <span>-</span>
          </div>

          <div>
            <span>内容侵权证明</span>
            <span>-</span>
          </div>

          <div>
            <span>其他</span>
            <span>-</span>
          </div>
        </div>
      </el-card>

      <el-card class="card">
        <p class="sub-title">申诉歌曲</p>
        <info-item :track="track" ref="track" v-for="(track, index) in detail.trackList" :key="index"></info-item>
      </el-card>

      <el-card class="card">
        <p class="sub-title">审核记录</p>
        <history :list="detail.transferList"></history>
      </el-card>

      <el-card class="card">
        <div class="center">
          <el-button @click="handleClickSubmit" type="primary" v-if="detail && detail.reviewStatus === 0">提交</el-button>
          <el-button @click="handleClickBack" type="ghost">返回</el-button>
        </div>
      </el-card>
    </template>
  </div>
</template>

<script>
import copyrightService from '@/api/copyright'

import InfoItem from './components/InfoItem.vue'
import History from './components/History.vue'

import { reviewStatusMap, auditMap, userMap, fromMap } from '../const'

export default {
  name: 'CpCheckDetail',

  components: {
    InfoItem,
    History
  },

  data() {
    return {
      auditMap,
      reviewStatusMap,
      userMap,
      fromMap,
      detail: null,
      loading: true
    }
  },

  computed: {
    id() {
      return +this.$route.params.id
    }
  },

  created() {
    this.fetchData()
  },

  methods: {
    handleClickOpen(url) {
      open(url.replace(/^http:/, 'https:'))
    },

    handleClickBack() {
      this.$router.push({
        name: 'checkCpList'
      })
    },

    async fetchData() {
      try {
        this.detail = await copyrightService.findById({ id: this.id })
      } catch (e) {
        this.$message.error(e.message)
      }
      this.loading = false
    },

    async handleClickSubmit() {
      const tracksComps = this.$refs.track
      const trackList = []
      try {
        for (const track of tracksComps) {
          trackList.push(await track.getData())
        }
      } catch (e) {
        this.$message.warning('请完善信息')

        return
      }

      const detail = {
        ...this.detail,
        trackList
      }
      try {
        await copyrightService.audit(
          detail
        )
        this.$message.success('操作成功')
        this.$router.push({
          name: 'checkCpList'
        })
      } catch (e) {
        this.$message.error(e.message)
      }
    }
  },

}

</script>

<style lang="scss">
.detail-box {
  min-height: 400px;
}
.base-info {
  margin-top: 20px;

  > div {
    font-size: 14px;
    width: 25%;
    display: inline-block;
    line-height: 30px;

    span:first-child {
      width: 70px;
      font-weight: bold;
      display: inline-block;
    }
  }
}

.sub-title {
  font-size: 16px;
  font-weight: bold;
  border-left: 4px solid #4071ff;
  padding-left: 6px;
  margin-bottom: 20px;
}

.info {

  > div {
    font-size: 14px;
    width: 33%;
    display: inline-flex;
    line-height: 26px;

    &.license-file {
      width: 100%;
    }

    >span:last-child {
      flex: 1;
      white-space: wrap;
      overflow: hidden;
    }

    >span:first-child {
      width: 110px;
      font-weight: bold;
      display: inline-block;
      overflow: hidden;
    }
  }
}

.copyright-status {
  display: inline-block;
  vertical-align: top;
}

.license-file {
  width: 100%;
}

.card {
  margin-bottom: 18px;
}

</style>
